import { PascalCaseToCamelCase } from '@approvalmax/types';
import { objectHelpers } from '@approvalmax/utils';
import { backend, domain } from 'modules/data';

import { parseXeroTaxCode } from './XeroTaxCode';

export function parseXeroAccount(
    value: backend.IntegrationsXeroAccount | PascalCaseToCamelCase<backend.IntegrationsXeroAccount>
): domain.XeroAccount {
    return {
        id: objectHelpers.keyOf(value, 'id'),
        text: `${objectHelpers.keyOf(value, 'code')} - ${objectHelpers.keyOf(value, 'name')}`,
        name: objectHelpers.keyOf(value, 'name'),
        accountClass: objectHelpers.keyOf(value, 'accountClass'),
        accountCode: objectHelpers.keyOf(value, 'code'),
        taxCode: objectHelpers.keyOf(value, 'taxCode')
            ? parseXeroTaxCode(objectHelpers.keyOf(value, 'taxCode'))
            : undefined,
        systemAccount: objectHelpers.keyOf(value, 'systemAccount'),
    };
}
